
import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import PersonalInformation from './PersonalInformation';
import ViewEducation from './ViewEducation';
import ViewProjects from './ViewProjects';
import ViewMarks from './ViewMarks';
import ViewCertification from './ViewCertification';
import ViewProfilePic from './ViewProfilePic';

const ViewProfile =({userprops}) =>{

    const [percent, setPercent] = useState(50);
    const[aboutme,setAboutme] =useState(null);

    useEffect(() => {

        setAboutme(userprops.about);

    }, []);

    return(
    <>
      <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Personal Information
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <PersonalInformation user={userprops}/>
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Education
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ViewEducation user={userprops}/>
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Projects
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ViewProjects user={userprops}/>
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                     Skills
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            {userprops?.skillnames?.toString()}
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                     Marks
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ViewMarks user={userprops} />
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                     Certifications
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ViewCertification user={userprops}/>
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>
            </Accordion>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                   Profile Picture
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ViewProfilePic user={userprops} />
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>
            </Accordion>


            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        About Me
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                        <textarea
                      className="form-control"
                      rows="8"
                      id="comment" value={aboutme}
                    ></textarea>
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

    </>)
}
export default ViewProfile